import React from 'react';
import { Section } from './ui/Section';
import { useCountUp } from '../hooks/useCountUp';
import { motion } from 'framer-motion';
export default function PainSection() {
  const {
    count,
    ref
  } = useCountUp(45, 2000, true);
  return <Section className="bg-brand-cream-dark relative overflow-hidden" data-id="element-255">
      {/* Subtle warm-to-red gradient wash */}
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} transition={{
      duration: 1.5
    }} className="absolute inset-0 bg-gradient-to-b from-transparent via-red-50/50 to-transparent pointer-events-none" data-id="element-256" />

      {/* Abstract soft blobs instead of clock */}
      <div className="absolute -right-20 -top-20 w-72 h-72 bg-red-100/40 rounded-full blur-3xl pointer-events-none" data-id="element-257" />
      <div className="absolute -left-16 bottom-0 w-56 h-56 bg-amber-100/30 rounded-full blur-3xl pointer-events-none" data-id="element-258" />
      <div className="absolute right-1/4 bottom-1/4 w-40 h-40 bg-brand-purple/5 rounded-full blur-2xl pointer-events-none" data-id="element-259" />

      <div className="relative z-10" data-id="element-260">
        <h2 className="font-heading text-4xl md:text-5xl text-slate-900 mb-12 text-center uppercase tracking-wide" data-id="element-261">
          Tu problema no es cocinar.{' '}
          <span className="text-brand-brown" data-id="element-262">Es decidir.</span>
        </h2>

        <div className="text-center mb-16" ref={ref} data-id="element-263">
          <div className="text-6xl md:text-8xl font-bold text-slate-900 mb-2 tabular-nums leading-none" data-id="element-264">
            {count}
          </div>
          <p className="text-xl text-red-500 font-medium uppercase tracking-widest" data-id="element-265">
            minutos diarios perdidos
          </p>
          <p className="text-slate-400 text-sm" data-id="element-266">decidiendo qué comer</p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-267">
          <div className="space-y-6" data-id="element-268">
            <p className="text-xl text-slate-600" data-id="element-269">
              Lo que te drena no es picar cebolla. Es esto:
            </p>
            <ul className="space-y-4" data-id="element-270">
              {['decidir,', 'volver a decidir,', 'justificar,', 'negociar,', 'improvisar.'].map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: i * 0.1
            }} className="flex items-center text-2xl md:text-3xl font-heading text-slate-800 uppercase tracking-wide" data-id="element-271">
                  <span className="w-3 h-3 bg-red-500 rounded-full mr-4 shadow-[0_0_12px_rgba(239,68,68,0.6)] animate-pulse" data-id="element-272" />
                  {item}
                </motion.li>)}
            </ul>
          </div>

          <div className="bg-white p-8 rounded-2xl border border-slate-200 shadow-lg" data-id="element-273">
            <p className="text-xl md:text-2xl text-slate-600 leading-relaxed mb-6" data-id="element-274">
              Todos los días. A las 6pm tu mente no está disponible para eso.
            </p>
            <p className="text-xl md:text-2xl text-slate-800 font-medium leading-relaxed" data-id="element-275">
              Y ahí es cuando ganas «la solución rápida» (takeout, cereal, lo
              que sea) y pierdes lo que de verdad quieres:{' '}
              <span className="text-brand-purple underline decoration-2 underline-offset-4 font-bold" data-id="element-276">
                calma
              </span>
              .
            </p>
          </div>
        </div>
      </div>
    </Section>;
}